import React from "react";
import { Navigate } from "react-router-dom";

import AuthService from "../services/auth.service";

// Restricts a route to users holding at least one of `allowedRoles`.
// Roles are stored like "ROLE_MODERATOR", "ROLE_ADMIN" in localStorage.
const RequireRole = ({ allowedRoles, children }) => {
  const user = AuthService.getCurrentUser();

  if (!user) {
    return <Navigate to="/" replace />;
  }

  const roles = user.roles || [];
  const permitted = allowedRoles.some((r) => roles.includes(r));

  if (!permitted) {
    return (
      <div className="container mt-4">
        <div className="alert alert-danger">
          You need moderator or admin access to view this page.
        </div>
      </div>
    );
  }

  return children;
};

export default RequireRole;
